import { connect } from "react-redux";
import { useEffect } from "react";
import { updateRequirements } from "../../../redux/actions/DeploymentActions";

function ReqCalculator({
                           custom,
                           currentApp, featuresData, instanceData,
                           bodyStack, bodyBuilder,
                           dispatch
                       }) {

    useEffect(() => {

        let ram = 0;
        let storage = 0;
        let cpu = 0;
        let bandwidth = 0;
        let consumers = [];

        const addConsumer = (consumer, group) => {

            const adaptReq = req => !isNaN(parseFloat(req)) ? parseFloat(req) : 0;
            const fixCalculation = req => parseFloat(req.toPrecision(12));

            const cRam = adaptReq(consumer?.ram_size || consumer?.ram);
            const cStorage = adaptReq(consumer?.disk_size || consumer?.storage);
            const cCpu = adaptReq(consumer?.cpu);
            const cBandwidth = adaptReq(consumer?.bandwidth);

            if (!cRam && !cStorage) return;

            ram = fixCalculation(ram + cRam);
            storage = fixCalculation(storage + cStorage);
            cpu = fixCalculation(cpu + cCpu);
            bandwidth = fixCalculation(bandwidth + cBandwidth);

            consumers.push({
                name: consumer?.name || consumer?.title || consumer?.code || consumer?._id || 'Undefined consumer',
                ram: cRam,
                storage: cStorage,
                cpu: cCpu,
                bandwidth: cBandwidth,
                group: group || 'other',
            })
        }

        // calculate stack basic requirements
        addConsumer(currentApp, 'application');
        // calculate predefined feature apps and subscriptions
        [
            ...bodyStack.subscriptions,
            ...(!custom ? bodyStack.extended_features : []),
            ...(!custom ? bodyStack.integrated_features : []),
        ].map(code => {
            const found = featuresData.features.find(f => f.code === code);
            if (found) addConsumer(found, found.type === 'subscriptions' ? 'subscriptions' : 'feature');
        });
        // calculate OS image requirements
        // instanceData
        const image = instanceData.images?.find(i => (
            i.id === bodyStack.os
            || i.code === bodyStack.os
            || i.name === bodyStack.os
        ));

        if (image) addConsumer(image, 'image');

        // calculate apps
        if (!custom) {
            // calculate predefined web and service apps
            const varsData = [...(currentApp?.apps || []), ...(currentApp?.services || [])];
            bodyStack.vars.map(app => {
                const found = varsData.find(a => a._id === app._id);
                if (found) addConsumer(found, found.type);
            });
        } else {
            // calculate user selected apps in custom deployment
            const appsData = [
                ...(bodyBuilder.web || []),
                ...(bodyBuilder.service || []),
                ...(bodyBuilder.feature || []),
            ];
            appsData.map(app => addConsumer(app, app.type));
        }


        dispatch(updateRequirements({
            ram,
            storage,
            cpu,
            bandwidth,
            consumers,
        }))

    }, [
        currentApp,
        bodyStack.subscriptions,
        bodyStack.extended_features,
        bodyStack.integrated_features,
        bodyStack.vars,
        bodyStack.os,
        bodyBuilder.web,
        bodyBuilder.feature,
        bodyBuilder.service,
    ])

    return null
}

const mapStateToProps = state => ({
    currentApp: state.deployment.currentApp,
    bodyStack: state.deployment.bodyStack,
    bodyBuilder: state.deployment.bodyBuilder,
    featuresData: state.deployment.featuresData,
    instanceData: state.deployment.instanceData,
});

export default connect(mapStateToProps)(ReqCalculator)